"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconInvisible = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M64.88 33.81A54.24 54.24 0 0 0 50.8 23.18l-4.82 6A12.42 12.42 0 0 1 31.59 47l-2.73 3.38A29.91 29.91 0 0 0 35 51c16.31 0 29.34-14.21 29.88-14.81a1.78 1.78 0 0 0 0-2.38z"
  }), _react["default"].createElement("path", {
    d: "M43.74 36.5a5.27 5.27 0 0 1-3.61-.11l-6 7.45a8.86 8.86 0 0 0 9.63-7.34zM50.37 16.17a2.54 2.54 0 0 0-.37-3.51 2.5 2.5 0 0 0-3.52.37l-5.35 6.63A29.9 29.9 0 0 0 35 19C18.69 19 5.66 33.21 5.12 33.81a1.78 1.78 0 0 0 0 2.37 54.25 54.25 0 0 0 14.07 10.64L15 51.95a2.49 2.49 0 0 0 3.3 3.65 2.47 2.47 0 0 0 .59-.51zM22.56 35a12.41 12.41 0 0 1 15.83-12l-2.53 3.13a8.19 8.19 0 0 0-.87-.06 8.88 8.88 0 0 0-8.46 11.6L24 40.84A12.36 12.36 0 0 1 22.56 35z"
  })),
  height: undefined,
  width: undefined
});
IconInvisible.displayName = 'IconInvisible';
var _default = IconInvisible;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/invisible.js
// module id = 577
// module chunks = 0